<template>
  <v-form @submit.prevent="submit">
    <v-text-field
      v-model="Hotel.name"
      label="Nome"
      :loading="loading"
      :error-messages="error.name || ''"
      required
    ></v-text-field>
    <v-text-field
      v-model="Hotel.address"
      label="Indirizzo"
      :loading="loading"
      :error-messages="error.address || ''"
      required
    ></v-text-field>
    <form-actions :loading="loading" @undo="reset" @submit="submit" />
  </v-form>
</template>

<script>
import { cloneDeep } from "@/lodash"

import models from "@/models"

export default {
  props: {
    withData: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      Hotel: {},
      personModel: models.Person,
    }
  },
  watch: {
    withData: {
      handler: "reset",
      deep: true,
    },
  },
  methods: {
    reset() {
      this.Hotel = cloneDeep(this.withData)
    },
    submit() {
      this.$emit("submit", this.Hotel)
    },
  },
}
</script>
